import React from 'react';
import {
    Box,
    Grid,
    Typography,
    FormControl,
    Select,
    MenuItem,
    InputLabel
} from '@mui/material';
import CustomSwitch from '../../../custom/customSwitch';
import  customOptions  from '../../../custom-options';

export default function AdditionalInsurance({formData, handleAdditionalInsuranceChange, handleSelectChange}) {
    const getLabel = (id) => {
        const option = customOptions.find(o => o.id === id);
        return option?.localizedTitles?.["de"] || id;
    };
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h5" sx={{mt: 2, mb: 1}}>
                        Zusatzversicherung:
                    </Typography>

                    <Box sx={{display: 'flex', alignItems: 'center', mt: 2}}>
                        <Typography variant="body1" sx={{mr: 2, width: 140}}>
                            Standardoption:
                        </Typography>
                        <CustomSwitch
                            checked={formData.standard || false}
                            onChange={handleAdditionalInsuranceChange}
                            name="standard"
                        />
                    </Box>

                    <Box sx={{display: 'flex', alignItems: 'center', mt: 2}}>
                        <Typography variant="body1" sx={{mr: 2, width: 140}}>
                            HMO:
                        </Typography>
                        <CustomSwitch
                            checked={formData.hmo || false}
                            onChange={handleAdditionalInsuranceChange}
                            name="hmo"
                        />
                    </Box>

                    <Box sx={{display: 'flex', alignItems: 'center', mt: 2}}>
                        <Typography variant="body1" sx={{mr: 2, width: 140}}>
                            Hausarzt:
                        </Typography>
                        <CustomSwitch
                            checked={formData.familyDoctor || false}
                            onChange={handleAdditionalInsuranceChange}
                            name="familyDoctor"
                        />
                    </Box>

                    <Box sx={{display: 'flex', alignItems: 'center', mt: 2}}>
                        <Typography variant="body1" sx={{mr: 2, width: 140}}>
                            Telemedizin:
                        </Typography>
                        <CustomSwitch
                            checked={formData.telemedicine || false}
                            onChange={handleAdditionalInsuranceChange}
                            name="telemedicine"
                        />
                    </Box>

                    <Box sx={{mt: 4, width: 300}}>
                        <FormControl fullWidth variant="standard">
                            <InputLabel>Optional ein Paket auswählen</InputLabel>
                            <Select
                                name="additionalInsurancePackage"
                                value={formData.additionalInsurancePackage || ''}
                                label="Paket auswählen"
                                onChange={handleSelectChange}
                            >
                                <MenuItem value="solid_basic">Bronze</MenuItem>
                                <MenuItem value="best_value">Silber</MenuItem>
                                <MenuItem value="premium">Gold</MenuItem>
                                <MenuItem value="custom">Individuell</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {formData.additionalInsurancePackage === 'custom' && (
                        <Box sx={{mt: 3, width: 300}}>
                            <FormControl fullWidth variant="standard">

                                <InputLabel>Zusatzleistungen</InputLabel>

                                <Select
                                    multiple
                                    name="additionalInsuranceCustomOption"
                                    value={formData.additionalInsuranceCustomOption || []}
                                    onChange={handleSelectChange}
                                    renderValue={(selected) =>
                                        selected.map(id => getLabel(id)).join(', ')
                                    }
                                >

                                    {customOptions.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.localizedTitles["de"]}
                                        </MenuItem>
                                    ))}

                                </Select>

                            </FormControl>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}
